import { css } from '@emotion/react';

export const SizeStyle = ({
	w,
	wPct,
	wAuto,
	h,
	hPct,
	fullWidth,
	fullHeight,
	r,
}: {
	w?: number;
	wPct?: number;
	wAuto?: boolean;
	h?: number;
	hPct?: number;
	fullWidth?: boolean;
	fullHeight?: boolean;
	r?: number;
}) => css`
	${!!w &&
	css`
		width: ${w}px;
	`};

	${!!wPct &&
	css`
		width: ${wPct}%;
	`};

	${!!wAuto &&
	css`
		width: auto;
	`};

	${!!h &&
	css`
		height: ${h}px;
	`};

	${!!hPct &&
	css`
		width: ${hPct}%;
	`};

	${!!fullWidth &&
	css`
		width: 100%;
	`};

	${!!fullHeight &&
	css`
		height: 100%;
	`}

	${!!r &&
	css`
		width: ${r}px;
		height: ${r}px;
	`}
`;
